import React from 'react';

const ReferralInfoContext = React.createContext({
  referralInfo: undefined,
  ensureReferralInfo: () => {},
});

export default ReferralInfoContext;
